export default __webpack_public_path__ + "static/hutch-28a07cd2889ecac93735897e46b6005b.png";